import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getProducts as getProductsApi,
  deleteProducts as deleteProductsApi,
  getOrders as getOrdersApi,
  getSellers as getSellersApi,
  getCustomers as getCustomersApi,
  updateOrder as updateOrderApi,
  deleteOrder as deleteOrderApi,
  addNewOrder as addNewOrderApi,
  addNewCustomer as addNewCustomerApi,
  updateCustomer as updateCustomerApi,
  deleteCustomer as deleteCustomerApi,
  addNewProduct as addNewProductApi,
  updateProduct as updateProductApi,
} from '../../helpers/fakebackend_helper';

export const getProducts = createAsyncThunk(
  'ecommerce/getProducts',
  async () => {
    try {
      const response = getProductsApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOrders = createAsyncThunk('ecommerce/getOrders', async () => {
  try {
    const response = getOrdersApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getSellers = createAsyncThunk('ecommerce/getSellers', async () => {
  try {
    const response = getSellersApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getCustomers = createAsyncThunk(
  'ecommerce/getCustomers',
  async () => {
    try {
      const response = getCustomersApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteProducts = createAsyncThunk(
  'ecommerce/deleteProducts',
  async product => {
    try {
      const response = deleteProductsApi(product);
      notify.success('Product deleted successfully.');
      return { product, ...response };
    } catch (error) {
      notify.apiError(error, 'delete product');
      return error;
    }
  }
);

export const updateOrder = createAsyncThunk(
  'ecommerce/updateOrder',
  async order => {
    try {
      const response = updateOrderApi(order);
      const data = await response;
      notify.success('Order updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update order');
      return error;
    }
  }
);

export const addNewProduct = createAsyncThunk(
  'ecommerce/addNewProduct',
  async product => {
    try {
      const response = addNewProductApi(product);
      const data = await response;
      notify.success('Product added successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'add product');
      return error;
    }
  }
);

export const updateProduct = createAsyncThunk(
  'ecommerce/updateProduct',
  async product => {
    try {
      const response = updateProductApi(product);
      const data = await response;
      notify.success('Product updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update product');
      return error;
    }
  }
);

export const deleteOrder = createAsyncThunk(
  'ecommerce/deleteOrder',
  async order => {
    try {
      const response = deleteOrderApi(order);
      notify.success('Order deleted successfully.');
      return { order, ...response };
    } catch (error) {
      notify.apiError(error, 'delete order');
      return error;
    }
  }
);

export const addNewOrder = createAsyncThunk(
  'ecommerce/addNewOrder',
  async order => {
    try {
      const response = addNewOrderApi(order);
      const data = await response;
      notify.success('Order added successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'add order');
      return error;
    }
  }
);

export const updateCustomer = createAsyncThunk(
  'ecommerce/updateCustomer',
  async customer => {
    try {
      const response = updateCustomerApi(customer);
      const data = await response;
      notify.success('Customer updated successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'update customer');
      return error;
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  'ecommerce/deleteCustomer',
  async customer => {
    try {
      const response = deleteCustomerApi(customer);
      notify.success('Customer deleted successfully.');
      return { customer, ...response };
    } catch (error) {
      notify.apiError(error, 'delete customer');
      return error;
    }
  }
);

export const addNewCustomer = createAsyncThunk(
  'ecommerce/addNewCustomer',
  async customer => {
    try {
      const response = addNewCustomerApi(customer);
      const data = await response;
      notify.success('Customer added successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'add customer');
      return error;
    }
  }
);
